import _ from 'underscore';

export const DEFAULT_ACTIVITY = { trace: _.noop, error: _.noop };

export const DefaultCurrencyCode = 'USD';

export const WebsiteValidationStatus = {
  Valid: 'Valid',
  URLNotValid: 'URLNotValid',
  URLAdvertisedBefore: 'URLAdvertisedBefore',
  MTError: 'MTError', // only used in UI
};

export const couponTypes = {
  Acquisition: 1,
  Retention: 2,
  Performance: 3,
  Percent: 4,
};

export const transformDateFormat = (rawDate) => {
  if (!rawDate) {
    return '';
  }
  const date = rawDate.substring(0, 10);
  const year = date.substring(0, 4);
  const month = date.substring(5, 7);
  const day = date.slice(-2);
  return `${month}/${day}/${year}`;
};

/**
 * Check if the provided PST time is expired. (Used mainly in coupon
 * scenarios where coupon expiry time is always in PST without timezone info).
 * @param {string} expiryDatePST time value in PST without timezone
 * @returns {bool} If the time is expired per local time.
 */
export const HasDateExpiredInPST = (expiryDatePST) => {
  const localNow = new Date();
  const utcNow = localNow.getTime();
  // Expiry date is in PST
  const localExpiry = new Date(`${expiryDatePST}-08:00`);
  const utcExpiry = localExpiry.getTime();

  return utcNow > utcExpiry;
};

const monetaryOptions = {
  compact: 'short',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
/**
 * Format cost, spend number with currency symbol and abbreviation.
 * Decimals: always 2 decimals
 * Example: $323.00K
 * @param {number} value - value to be formatted
 * @param {Object} i18n - Localization component
 * @param {string} currency - currency code
 * @param {Object} options - formatting options
 * @return {string} formatted string
 */
export const formatCost = (value, i18n, currency, options = monetaryOptions) =>
  i18n.formatCurrency(value, currency, options);

export const getCouponTerms = (couponString, language) => {
  // Special handle promo chat coupon ALIREONEESCPFY23US500 as the terms set for this coupon are different.
  if (couponString === 'ALIREONEESCPFY23US500') {
    return 'https://help.ads.microsoft.com/apex/index/3/en/50829';
  }

  // Maps locale to localized terms and conditions
  const languageCouponTermsMapping = {
    en: 'https://help.ads.microsoft.com/#apex/ads/en-us/60347/3-500',
    es: 'https://help.ads.microsoft.com/#apex/ads/es-es/60347/3-500',
    it: 'https://help.ads.microsoft.com/#apex/ads/it-it/60347/3-500',
    de: 'https://help.ads.microsoft.com/#apex/ads/de-de/60347/3-500',
    fr: 'https://help.ads.microsoft.com/#apex/ads/fr-fr/60347/3-500',
    pt: 'https://help.ads.microsoft.com/#apex/ads/pt-br/60347/3-500',
  };

  // IF ESCGlobal pilot is on, map to localized terms link
  return _.get(languageCouponTermsMapping, language, languageCouponTermsMapping.en);
};

export const getIneligibleText = ({ websiteValidationResult, i18n }) => {
  if (websiteValidationResult === WebsiteValidationStatus.URLAdvertisedBefore) {
    return i18n.getString(_TL_('It looks like this website has already been advertised on Microsoft Advertising. This coupon code is valid for new customers.'));
  } else if (websiteValidationResult === WebsiteValidationStatus.URLNotValid) {
    return i18n.getString(_TL_('To redeem this promotional offer, please make sure that your campaign\'s address is valid and entered correctly. We couldn\'t verify that your campaign\'s website is online.'));
  } else if (websiteValidationResult === WebsiteValidationStatus.MTError) {
    // Show general error when failed to validate website for coupon
    return i18n.getString(_TL_('Unfortunately, we encountered a system issue while processing your request. Please try again.'));
  }
  return '';
};
